import { SocketState, SocketGettersKeys, SocketGettersReturns } from './socket';
import { SessionGettersKeys, SessionGettersReturns } from './session';
import { BoardFullState, BoardGettersReturns, BoardGettersKeys } from './board';
import { JitsiGettersKeys, JitsiGettersReturns } from './jitsi';
import { InterfaceState, InterfaceGettersKeys, InterfaceGettersReturns } from './interface';
import { StageGettersKeys, StageGettersReturns } from './stageState';
import { ElementGettersKeys, ElementGettersReturns } from './element';

export interface FullState extends RootState {
  Sockets: SocketState;
  Board: BoardFullState;
  Interface: InterfaceState;
}

export type RootGettersKeys = GettersKeys &
  SocketGettersKeys &
  SessionGettersKeys &
  BoardGettersKeys &
  JitsiGettersKeys &
  InterfaceGettersKeys &
  ElementGettersKeys &
  StageGettersKeys;

export type RootGettersReturns = GettersReturns &
  SocketGettersReturns &
  SessionGettersReturns &
  BoardGettersReturns &
  JitsiGettersReturns &
  InterfaceGettersReturns &
  ElementGettersReturns &
  StageGettersReturns;

/* ROOT STATE */

export interface RootState {
  version: string;
  tnc_accepted: boolean;
  tnc_accepted_at: null | string;
  currentUser: User | null;
  jwt: string | null;
}

export interface LoggedInUser {
  fullName: string;
  email: string;
  id: number;
  type: 'User';
  colorCode: string;
}

export interface GuestUser {
  fullName: string;
  session_pin: string;
  id: number;
  type: 'Guest';
}

export type User = LoggedInUser | GuestUser;

/* ACTIONS */

export enum ActionsKeys {
  SET_TOS_ACCEPTED = 'SET_TOS_ACCEPTED',
  SET_CURRENT_USER = 'SET_CURRENT_USER',
  CHECK_LOGGED_IN = 'CHECK_LOGGED_IN',
  LOGOUT = 'LOGOUT',
  OPEN_DASHBOARD = 'OPEN_DASHBOARD',
  ROLE_CHANGING = 'ROLE_CHANGING',
}

export interface ActionsPayload {
  [ActionsKeys.SET_CURRENT_USER]: { user: User; jwt: NonNullable<RootState['jwt']> };
  [ActionsKeys.CHECK_LOGGED_IN]: void;
  [ActionsKeys.OPEN_DASHBOARD]: void;
  [ActionsKeys.LOGOUT]: void;
}

/* MUTATIONS */

export enum MutationsKeys {
  SET_TOS_ACCEPTED = 'SET_TOS_ACCEPTED',
  SET_CURRENT_USER = 'SET_CURRENT_USER',
  CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER',
  RESET_STATE = 'RESET_STATE',
}

export interface MutationsPayload {
  [MutationsKeys.SET_CURRENT_USER]: { user: User; jwt: NonNullable<RootState['jwt']> };
  [MutationsKeys.CLEAR_CURRENT_USER]: void;
  [MutationsKeys.RESET_STATE]: void;
}

/* GETTERS */

export enum GettersKeys {
  tosAccepted = 'tosAccepted',
  isLoggedIn = 'isLoggedIn',
  currentUser = 'currentUser',
  isGuest = 'isGuest',
  jwt = 'jwt',
}

export interface GettersReturns {
  [GettersKeys.isLoggedIn]: boolean;
  [GettersKeys.isGuest]: boolean;
  [GettersKeys.currentUser]: RootState['currentUser'];
  [GettersKeys.jwt]: RootState['jwt'];
}
